<template>
  <div>
    <sdPageHeader :title="$t('pages.settings.title')">
      <template v-slot:buttons> </template>
    </sdPageHeader>
    <Main>
      <a-row :gutter="25">
        <a-col :xxl="6" :lg="8" :md="10" :xs="24">
          <ProfileAuthorBox>
            <author-box />
          </ProfileAuthorBox>
        </a-col>
        <a-col :xxl="18" :lg="16" :md="14" :xs="24">
          <SettingWrapper>
            <Suspense>
              <template #default>
                <router-view></router-view>
              </template>
              <template #fallback>
                <div class="spin">
                  <a-spin />
                </div>
              </template>
            </Suspense>
          </SettingWrapper>
        </a-col>
      </a-row>
    </Main>
  </div>
</template>

<script>
import { Main } from '../styled';
import { SettingWrapper, ProfileAuthorBox } from './overview/style';
import AuthorBox from './overview/ProfileAuthorBox';
export default {
  name: 'Settings',
  components: {
    Main,
    SettingWrapper,
    AuthorBox,
    ProfileAuthorBox,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  mounted() {
    this.$store.dispatch('setting/get');
  },
};
</script>
